import { Spinner, theme, Avatar, AvatarSize } from '@ketch-com/deck'
import { Box, Typography } from '@mui/material'
import { useDataSentryContext } from 'pages/dataSentry/context/DataSentryContext'
import { formatCountCopy } from 'pages/dataSentry/utils/formatCountCopy'

export const EventsVolumeCard: React.FC = () => {
  const { eventsSummary, isEventsSummaryLoading } = useDataSentryContext()
  const eventsVolume = eventsSummary?.total ? formatCountCopy(eventsSummary.total) : 'Unknown'
  return (
    <Box display="flex" justifyContent="center" width="100%" gap={eventsSummary?.total ? 4 : 0}>
      {isEventsSummaryLoading ? (
        <Box display="flex" alignItems="center" justifyContent="center" minHeight={150}>
          <Spinner size="32px" thickness={2.5} />
        </Box>
      ) : (
        <>
          <Box display="flex" flexDirection="column">
            <Typography variant="smallLabel" color={theme.palette.Text.Secondary} my={1} textAlign="center">
              Data-Collection Events Volume
            </Typography>
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              minHeight={120}
              gap={0.5}
            >
              {eventsSummary?.total ? (
                <>
                  <Typography variant="h4">{eventsVolume}</Typography>
                  <Typography variant="smallBody">Events Total</Typography>
                </>
              ) : (
                <Box>
                  <Avatar
                    icon="FUnknown"
                    textColor={theme.palette.Text.Secondary}
                    borderColor={theme.palette.Black.o8}
                    size={AvatarSize['2xlarge']}
                    isLogo
                  />
                  <Typography variant="label" color={theme.palette.Text.Secondary}>
                    No Data
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>
        </>
      )}
    </Box>
  )
}
